import { COLORS, DEFAULT_TRANSITION_ALL } from "utils/styles";

import styled from "styled-components";

const getStyles = (isLink) => `
  ${DEFAULT_TRANSITION_ALL};
  appearance: none;
  margin: 0;
  padding: 0;
  background: none;
  outline: none;
  border: none;
  color: ${COLORS.MEDIUM_GRAY};
  transform-origin: top;

  & > i {
    margin: 0 !important;
  }

  &:hover {
    color: ${COLORS.BLACK};
    transform: scale(1.2) translateY(-3px);
  }

  &:focus,
  &:active {
    outline: none;
    color: ${COLORS.DARK_BLACK};
    transform: scale(1.1) translateY(-2px);
  }
`;

export default styled.button`
  ${getStyles()}
`;

export const IconLink = styled.a`
  ${getStyles()}
`;
